// ISO 3166-1 alpha-2 codes. Labels são gerados via Intl.DisplayNames,
// então os nomes localizam automaticamente conforme o idioma do site.
const COUNTRY_CODES = [
  "AF", "AL", "DZ", "AD", "AO", "AG", "AR", "AM", "AU", "AT",
  "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BT",
  "BO", "BA", "BW", "BR", "BN", "BG", "BF", "BI", "CV", "KH",
  "CM", "CA", "CF", "TD", "CL", "CN", "CO", "KM", "CG", "CD",
  "CR", "CI", "HR", "CU", "CY", "CZ", "DK", "DJ", "DM", "DO",
  "EC", "EG", "SV", "GQ", "ER", "EE", "SZ", "ET", "FJ", "FI",
  "FR", "GA", "GM", "GE", "DE", "GH", "GR", "GD", "GT", "GN",
  "GW", "GY", "HT", "HN", "HU", "IS", "IN", "ID", "IR", "IQ",
  "IE", "IL", "IT", "JM", "JP", "JO", "KZ", "KE", "KI", "KP",
  "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI",
  "LT", "LU", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MR",
  "MU", "MX", "FM", "MD", "MC", "MN", "ME", "MA", "MZ", "MM",
  "NA", "NR", "NP", "NL", "NZ", "NI", "NE", "NG", "MK", "NO",
  "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PL",
  "PT", "QA", "RO", "RU", "RW", "KN", "LC", "VC", "WS", "SM",
  "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SK", "SI", "SB",
  "SO", "ZA", "SS", "ES", "LK", "SD", "SR", "SE", "CH", "SY",
  "TW", "TJ", "TZ", "TH", "TL", "TG", "TO", "TT", "TN", "TR",
  "TM", "TV", "UG", "UA", "AE", "GB", "US", "UY", "UZ", "VU",
  "VA", "VE", "VN", "YE", "ZM", "ZW",
];

const cachedOptions = {};

export const getCountryOptions = (lang) => {
  const locale = lang === "pt" ? "pt" : "en";
  if (cachedOptions[locale]) return cachedOptions[locale];

  let displayNames = null;
  try {
    displayNames = new Intl.DisplayNames([locale], { type: "region" });
  } catch {
    // navegador sem suporte: cai no próprio código como label
  }

  const options = COUNTRY_CODES.map((code) => {
    let label = code;
    if (displayNames) {
      try {
        label = displayNames.of(code) || code;
      } catch {}
    }
    return { value: code, label };
  }).sort((a, b) => a.label.localeCompare(b.label, locale));

  // Brasil fixado no topo — maioria do público
  const brIndex = options.findIndex((opt) => opt.value === "BR");
  if (brIndex > 0) {
    const [br] = options.splice(brIndex, 1);
    options.unshift(br);
  }

  cachedOptions[locale] = options;
  return options;
};

export default getCountryOptions;
